import styled from 'styled-components'

import { colors, textStyles } from '../../theme'

export const ActionButton = styled.button<{ isActive: boolean }>`
  ${textStyles.label}
  background-color: ${colors.pureWhite};
  color: ${colors.pureBlack};
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 1.1rem 2rem 0.7rem;
  min-height: 3.6rem;
  min-width: 14rem;
  border: 1px solid;
  border-radius: 3rem;
  user-select: none;
  cursor: pointer;
  transition: color 0.3s, border-color 0.3s, background-color 0.3s;

  &:hover {
    background-color: ${colors.lightGrey};
  }
`
